/**
  * @class meleActor
  * @description
  *
  * # Purpose
  * Abstract parent class for `<mele-actor-xxx>` custom web elements for showing data in <mele-channel>
  */

import meleElement from 'meleElement'

const PROPERTIES = _.extend({}, {
}, meleElement._properties)

export default class meleActor extends meleElement {
  init() {
    super.init()
  }

  signature() {
    const id = this.parentElement.ch
    if(id!==undefined && id!==null && String(id).length>0) return this.tagName+'#'+id
  } // signature
} // class meleActor

meleActor._properties = PROPERTIES
meleActor.observedAttributes = _.keys(PROPERTIES)
